export default __webpack_public_path__ + "static/media/Logo.a18c5b40.png";